import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { Observable, Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { ActivatedRoute } from '@angular/router';

import { Todo } from '../../../models/todo';
import { selectTodos } from '../../../store/todo/todo.selector';
import { deleteOne, editOne } from '../../../store/todo/todo.actions';

@Component({
  selector: 'app-todo-detail',
  imports: [MatFormFieldModule, MatInputModule, MatSelectModule, ReactiveFormsModule, MatButtonModule],
  templateUrl: './todo-detail.component.html',
  styleUrl: './todo-detail.component.scss'
})
export class TodoDetailComponent implements OnInit, OnDestroy {
  form: FormGroup;
  todos$: Observable<Todo[]>;
  todoSub: Subscription = new Subscription;

  constructor(
    private fb: FormBuilder,
    private store: Store,
    private route: ActivatedRoute,
  ) {
    this.form = this.fb.group({
      title: ['', Validators.required],
      description: ['', Validators.required],
      isCompleted: ['', Validators.required],
    });

    this.todos$ = this.store.select(selectTodos);
  }

  ngOnInit(): void {
    this.todoSub = this.todos$
      .subscribe((todos: Todo[]) => {
        const todo = todos.find((todo: Todo) => todo.id === +this.route.snapshot.params['id']);

        if (!todo) {
          return;
        }

        this.form.patchValue({
          title: todo.title,
          description: todo.description,
          isCompleted: String(todo.isCompleted)
        });
      });
  }

  onSubmit(): void {
    if (this.form.valid) {
      const todo = { ...this.form.value };
      todo.id = this.route.snapshot.paramMap.get('id');
      todo.isCompleted = !!todo.isCompleted; 

      this.store.dispatch(editOne({ todo }));
    }
  }

  onDelete(): void {
    if (this.form.valid) {
      const todo = { ...this.form.value };
      todo.id = this.route.snapshot.paramMap.get('id');
      todo.isCompleted = !!todo.isCompleted; 

      this.store.dispatch(deleteOne({ todo }));
    }
  }

  ngOnDestroy(): void {
    this.todoSub.unsubscribe();
  }

}
